import {
  AspectRatio,
  Box,
  Container,
  Heading,
  SimpleGrid,
  Tooltip,
} from '@chakra-ui/react'
import { MemberSpotlightArticle } from './MemberSpotlightArticle.types'
import NextImage from 'next/image'
import { InfoIcon } from '@chakra-ui/icons'
import { Gallery, Item } from 'react-photoswipe-gallery'
import { getPrefixedStorageURL } from '@/lib/getPrefixedStorageURL'
import { isImageFile } from '@/lib/isImageFIle'
import 'photoswipe/dist/photoswipe.css'

type SpotlightGalleryProps = {
  images?: MemberSpotlightArticle['gallery']
}

export const SpotlightGallery = (props: SpotlightGalleryProps) => {
  if (!props.images || props.images.length === 0) return null
  return (
    <Container maxW='6xl' pt={24} pos='relative' overflow='hidden'>
      <img
        src='/img/gears.webp'
        alt=''
        style={{
          position: 'absolute',
          top: '0',
          left: 0,
          width: '600px',
          transform: 'translateX(20%) rotate(-5deg)',
        }}
      />
      <Box
        opacity={0.6}
        p={2}
        pos='relative'
        left='-12px'
        zIndex='1'
        style={{
          rotate: '-4deg',
          transformOrigin: 'left bottom',
        }}>
        <Heading
          fontSize={{ base: '7xl', xl: '8xl' }}
          textAlign='center'
          top={4}
          position='relative'
          color='blue.700'>
          Full Gallery
        </Heading>
      </Box>
      <Gallery withCaption>
        <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing={4}>
          {props.images?.map(
            image =>
              isImageFile(image.url) && (
                <Item
                  id={image.id}
                  original={image.url}
                  thumbnail={`${getPrefixedStorageURL(
                    image.url,
                    'api'
                  )}?tr=project_card`}
                  width={image.width ?? '1600'}
                  height={image.height ?? '1600'}
                  caption={image.alt}
                  key={image.id}
                  cropped>
                  {({ ref, open }) => (
                    <Box
                      backgroundColor='gray.200'
                      as='a'
                      // @ts-ignore-next-line no-legacy-refs
                      ref={ref}
                      onClick={open}
                      position='relative'>
                      <AspectRatio ratio={4 / 3}>
                        <NextImage
                          src={image.url}
                          title={image.alt}
                          alt={image.alt ?? ''}
                          style={{ objectFit: 'cover' }}
                          width='720'
                          height='720'
                        />
                      </AspectRatio>
                      {image.alt && (
                        <Tooltip label={image.alt}>
                          <InfoIcon
                            backgroundColor='white'
                            borderRadius='full'
                            p='1px'
                            position='absolute'
                            bottom={2}
                            right={2}
                          />
                        </Tooltip>
                      )}
                    </Box>
                  )}
                </Item>
              )
          )}
        </SimpleGrid>
      </Gallery>
    </Container>
  )
}
